import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/700.css";
import "@fontsource/nunito/800.css";
import "@brovka/ui/tokens.css";
import "./styles.css";
import { App } from "./App.tsx";
import { api, boot, useApp } from "./state/app.ts";
import { flush } from "./lib/pending.ts";
import { db } from "./lib/db.ts";

// Код обновляется при следующем запуске (ARCHITECTURE 6.4): новая версия ждёт согласия пользователя.
if ("serviceWorker" in navigator) {
  const update = registerSW({
    onNeedRefresh: () => useApp.setState({ updateReady: true }),
  });
  window.addEventListener("brovka:update", () => void update(true));
}

// Ошибки клиента — в журнал сервера без ПДн (ARCHITECTURE 12).
function report(message: string, stack?: string) {
  void api.request("POST", "/v1/client-errors", { message, stack, route: location.pathname, app_version: __APP_VERSION__ }, { auth: false }).catch(() => {});
}
window.addEventListener("error", (e) => report(String(e.message), e.error?.stack));
window.addEventListener("unhandledrejection", (e) => report(String(e.reason?.message ?? e.reason), e.reason?.stack));
window.addEventListener("online", () => void flush(api, db));

void boot().then(() => void flush(api, db));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
